import { CREATE_AND_BIND_TEMPLATE, CREATE_TEMPLATE, HIDE_TRANSPORT_OVERLAY, SHOW_TRANSPORT_OVERLAY, TOGGLE_TRANSPORT_OVERLAY, } from '../actions';
export const initialState = {
    id: undefined,
    isTransportOverlayOpen: false,
    overlayTemplate: undefined,
    onDataRequired: [],
};
export function TransportOverlayReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_TRANSPORT_OVERLAY:
            return {
                id: action.payload.id || state.id,
                isTransportOverlayOpen: true,
                overlayTemplate: action.payload.overlayTemplate || state.overlayTemplate,
                onDataRequired: action.payload.onDataRequired || state.onDataRequired
            };
        case TOGGLE_TRANSPORT_OVERLAY:
            const isOpen = !state.isTransportOverlayOpen;
            return {
                id: action.payload.id,
                isTransportOverlayOpen: isOpen,
                overlayTemplate: isOpen ? action.payload.overlayTemplate : undefined,
                onDataRequired: isOpen ? action.payload.onDataRequired : []
            };
        case HIDE_TRANSPORT_OVERLAY:
            return {
                id: undefined,
                isTransportOverlayOpen: false,
                overlayTemplate: undefined,
                onDataRequired: []
            };
        case CREATE_TEMPLATE:
        case CREATE_AND_BIND_TEMPLATE:
            return {
                isTransportOverlayOpen: false,
                overlayTemplate: undefined,
                onDataRequired: []
            };
        default:
            return state;
    }
}
